<template>
    <div id="carouselExampleSlidesOnly" class="carousel slide" data-ride="carousel" data-interval="3000"
         data-pause="false">
        <div class="carousel-inner">
            <div class="carousel-item active">
                <img class="d-block w-100 slider-image" src="@/assets/images/Slider_Design.jpg" alt="First slide">
                <div class="carousel-caption container">
                    <img class="hero-logo" src="@/assets/images/pencil-white.png">
                    <h1 class="hero-title font-weight-bold">3D per<br>Il Design</h1>
                    <a href="#design" class="btn button-transp">Scopri di più</a>
                </div>
            </div>
            <div class="carousel-item">
                <img class="d-block w-100 slider-image" src="@/assets/images/Slider_Architettura.jpg"
                     alt="Second slide">
                <div class="carousel-caption container">
                    <img class="hero-logo" src="@/assets/images/compax-white.png">
                    <h1 class="hero-title font-weight-bold">3D Per<br>l'Architettura</h1>
                    <a href="#architettura" class="btn button-transp">Scopri di più</a>
                </div>
            </div>
            <div class="carousel-item">
                <img class="d-block w-100 slider-image" src="@/assets/images/Slider_Industria.jpg"
                     alt="Third slide">
                <div class="carousel-caption container">
                    <img class="hero-logo" src="@/assets/images/machine-white.png">
                    <h1 class="hero-title font-weight-bold">3D Per<br>l'Industria</h1>
                    <a href="#industria" class="btn button-transp">Scopri di più</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Slider"
    }
</script>

<style scoped>
    .carousel-caption {
        position: absolute;
        bottom: 35vh;
        right: 0 !important;
        left: 0 !important;
        z-index: 10;
        text-align: left
    }
    .hero-logo {
        height: 8rem;
        padding-bottom: 2rem;
    }

    .hero-title {
        font-size: 4.5rem;
    }

</style>